module.exports = __webpack_public_path__ + "img/daily-tournament-bg_768.8d6b5650.png";